"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iFetchRevisionSuccessData = exports.FETCH_AFTER_REVISION_FAILURE = exports.FETCH_AFTER_REVISION_SUCCESS = exports.FETCH_AFTER_REVISION_REQUEST = exports.FETCH_BEFORE_REVISION_FAILURE = exports.FETCH_BEFORE_REVISION_SUCCESS = exports.FETCH_BEFORE_REVISION_REQUEST = void 0;
const t = require("io-ts");
const TypesLib = require("@caddigital/sok-types");
exports.FETCH_BEFORE_REVISION_REQUEST = '@sok/compare/FETCH_BEFORE_REVISION_REQUEST';
exports.FETCH_BEFORE_REVISION_SUCCESS = '@sok/compare/FETCH_BEFORE_REVISION_SUCCESS';
exports.FETCH_BEFORE_REVISION_FAILURE = '@sok/compare/FETCH_BEFORE_REVISION_FAILURE';
exports.FETCH_AFTER_REVISION_REQUEST = '@sok/compare/FETCH_AFTER_REVISION_REQUEST';
exports.FETCH_AFTER_REVISION_SUCCESS = '@sok/compare/FETCH_AFTER_REVISION_SUCCESS';
exports.FETCH_AFTER_REVISION_FAILURE = '@sok/compare/FETCH_AFTER_REVISION_FAILURE';
exports.iFetchRevisionSuccessData = t.interface({
    payload: t.interface({
        node: TypesLib.File.iRevision
    })
});
//# sourceMappingURL=index.js.map